import {Project, XYPosition} from 'reactflow';

// Whether an `onConnectEnd` drop hit empty canvas (the pane or its background grid) rather than a node.
// Checks the pane class directly, not as an ancestor, since nodes are descendants of the pane.
export function isDropOnEmptyCanvas(event: MouseEvent | TouchEvent): boolean {
  const target = event.target as Element | null;
  return (
    target != null &&
    (target.classList.contains('react-flow__pane') || target.closest('.react-flow__background') != null)
  );
}

// Client-space point of an `onConnectEnd` event, or null. Uses `changedTouches` (`touches` is empty on end).
export function getClientPointFromConnectEvent(
  event: MouseEvent | TouchEvent
): {clientX: number; clientY: number} | null {
  const touchEvent = event as TouchEvent;
  const point = touchEvent.changedTouches != null ? touchEvent.changedTouches[0] : (event as MouseEvent);
  if (point == null) {
    return null;
  }
  return {clientX: point.clientX, clientY: point.clientY};
}

// Project a client-space point onto flow coords. `project` wants a pane-relative point, so subtract bounds.
// (Replaceable with `screenToFlowPosition` once reactflow is bumped past 11.6.)
export function projectClientPointToFlow(
  project: Project,
  clientX: number,
  clientY: number,
  paneElement: Element
): XYPosition {
  const paneBounds = paneElement.getBoundingClientRect();
  return project({x: clientX - paneBounds.left, y: clientY - paneBounds.top});
}
